import * as React from 'react';
import { useState, useEffect } from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import Modal from 'shared/components/Modal';
import Slide from './components/Slide';
import { getPartners } from '../../../../partners';

import './index.scss';

import * as arrowLeft from './static/img/arrow-left.svg';
import * as arrowRight from './static/img/arrow-right.svg';

interface Props {
  onClose: () => void;
  index: number;
  count: number;
}

const b = b_.with('main-page-partners-slider');

const Slider: React.FC<Props> = ({ onClose, index, count }) => {
  const { t } = useTranslation();
  const [[currentSlide, prevSlide], setCurrentSlide] = useState<[number, number | undefined]>([
    index,
    undefined,
  ]);

  const partners = getPartners(t);

  function slideToLeft() {
    if (currentSlide > 0) {
      setCurrentSlide([currentSlide - 1, currentSlide]);
    }
  }

  function slideToRight() {
    if (currentSlide < count - 1) {
      setCurrentSlide([currentSlide + 1, currentSlide]);
    }
  }

  const handleSlideChange = (e: KeyboardEvent) => {
    e.key === 'ArrowLeft' && slideToLeft();
    e.key === 'ArrowRight' && slideToRight();
  };

  useEffect(() => {
    window.addEventListener('keydown', handleSlideChange);

    return () => {
      window.removeEventListener('keydown', handleSlideChange);
    };
  });

  return (
    <Modal inSlider className={b()} onClose={onClose}>
      <div onClick={slideToLeft} className={b('left-arrow', { disabled: currentSlide <= 0 })}>
        <img src={arrowLeft} alt="" />
      </div>

      <div className={b('content')}>
        <Slide partner={partners[currentSlide]} key={currentSlide + 'current'} isActive />
        {prevSlide != undefined && <Slide partner={partners[prevSlide]} key={prevSlide + 'prev'} />}
      </div>

      <div
        onClick={slideToRight}
        className={b('right-arrow', { disabled: currentSlide >= count - 1 })}
      >
        <img src={arrowRight} alt="" />
      </div>
    </Modal>
  );
};

export default Slider;
